var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBq = function SvgIconBq(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#D80027"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 .001c-.011-.008-12.003 11.997-12 12 0-6.627 5.373-12 12-12M12 0c.011-.008 12.003 11.997 12 12 0-6.627-5.373-12-12-12"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#0052B4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24c-.011.008-12.003-11.997-12-12 0 6.627 5.373 12 12 12M12 23.999c.011.009 12.003-11.997 12-12 0 6.627-5.373 12-12 12"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "m12 6.26 1.295 3.986h4.19l-3.39 2.464 1.295 3.986L12 14.232l-3.39 2.464 1.294-3.986-3.39-2.464h4.19z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconBq;